import { createApp } from 'vue';
import App from './App.vue';
import router from './core/router';

import sentry from './core/helpers/sentry.helper';
import i18n from './i18n';

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(sentry);

app.mount('#app');
